module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAsklEQVRIS2NkIBL8//+f8X8Uyz6QcsZlf5wYGRn/E6OVkRhFIDX/4zil//3++QTEZmJll2Fc9P0pMXqJtyCaU+bfv5+PwRYwscsyLv0OtowQGLWAUAgxjAbRIAgiUA5liOeSYvhLKD7+SP779/cUJB8wmzEwsDzH63xmhv8MC789Y/wXybz/P8N/B4J+JUMBIwPjAdpbQPMgItbn/0fLIkJBNRpEhEKIYRgEEc0rfTKbLQCrR8ZHEe7kyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/function-service/ic_add.png
// module id = Onn/
// module chunks = 0